import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { fullDateTime } from 'Consts/DateFormats';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import LinkingAttemptLayout from 'Components/AdvisorApp/Viewport/LinkingAttempts/LinkingAttemptLayout';
import { CircularProgress } from '@material-ui/core';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  form: {
    padding: 0,
    margin: 0,
  },
  title: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  loading: {
    padding: theme.spacing(0, 3, 3, 3),
  },
});

export const LinkingAttemptsInlineFormOverride = fr.metaOverride()
  .overrideAll({
    _hideLabel: false,
    readonly: true,
    _customProps: {
      noWrap: false,
      hasTooltip: true,
    },
  })
  .typeOverride('date', {
    _displayTime: true,
    _formatString: fullDateTime,
  });

const LinkingAttemptForm = ({ classes, resource }) => {
  const [linkingAttemptNoteCollection, setLinkingAttemptNoteCollection] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getLinkingEvents() {
      try {
        const collection = await resource?.relationship(fr.relationships.linkingAttemptNote.name)?.link('related')?.get();

        if (collection?.resources().length() > 0) {
          setLinkingAttemptNoteCollection(collection);
        } else {
          // If the collection is empty, add a resource to the collection
          const collCopy = collection.copy();
          collCopy.create({
            addToCollection: true,
          });
          setLinkingAttemptNoteCollection(collCopy);
        }

        setLoading(false);
      } catch (err) {
        setLoading(false);
        displayErrorMessage(err, 'Failed to fetch linking attempt note');
      }
    }

    setLoading(true);
    getLinkingEvents();
  }, [resource]);

  return (
    <React.Fragment>
      <MetaFormInline
        resource={resource}
        layout={LinkingAttemptLayout}
        metaOverrideSet={LinkingAttemptsInlineFormOverride}
        readonly
      />
      { loading ? (
        <div className={classes.loading}>
          <Typography
            className={classes.title}
            color="primary"
            variant="h2"
          >
            Note
          </Typography>
          <CircularProgress />
        </div>
      ) : (
        linkingAttemptNoteCollection && <MetaCollectionFormInline
          classes={{
            form: classes.form,
          }}
          title="Note"
          collection={linkingAttemptNoteCollection}
        />
      )}
    </React.Fragment>
  );
};

LinkingAttemptForm.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(LinkingAttemptForm);
